<html>

<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css">
</head>

<body>
    <button (click)="routeToEvent()">
        <i class="fa fa-search"></i>

    </button>
</body>

</html>